import { supabase } from './supabaseClient';

export const fetchSettings = async () => {
    const { data, error } = await supabase
        .from('settings')
        .select('*');
    
    if (error) {
        console.error('Error fetching settings:', error);
        return null;
    }

    // Convert rows back to an object (mapping setting_key -> key)
    const settingsObj = {};
    data.forEach(row => {
        settingsObj[row.setting_key] = row.setting_value;
    });

    return Object.keys(settingsObj).length > 0 ? settingsObj : null;
};

export const updateSettings = async (settingsData) => {
    // Upsert each key/value pair mapping frontend keys to SQL columns
    const upserts = Object.entries(settingsData).map(([key, value]) => ({
        setting_key: key,
        setting_value: value
    }));

    const { data, error } = await supabase
        .from('settings')
        .upsert(upserts, { onConflict: 'setting_key' })
        .select();
    
    if (error) {
        console.error('Error updating settings:', error);
        throw error;
    }

    const updatedObj = {};
    data.forEach(row => {
        updatedObj[row.setting_key] = row.setting_value;
    });
    return updatedObj;
};
